import { input, output, TODO } from '@b2b/types/core';
import angular, { IOnChangesObject } from 'angular';
import invariant from 'tiny-invariant';
import { FormBuilder, FormBuilderOptions, FormDataField } from './types';

let id = 0;

export class FormBuilderController {
  static $inject = ['$element'];

  options = input<FormBuilderOptions>();
  sourceFormDefinition = input.required('');
  elementRef = output<{ ref: FormBuilderController }>();

  id = `acme-form-builder-${++id}`;
  private editorRef: TODO;

  initialized = false;

  constructor(private $element: JQuery) {}

  $onInit() {
    this.$element.addClass('acme-form-builder');

    this.validateInputs();
  }

  $onChanges(changes: IOnChangesObject) {
    if ((changes.options || changes.sourceFormDefinition) && !!this.options) {
      setTimeout(() => {
        this.initializeEditor();
      }, 0);
    }
  }

  setFormDefinition() {
    const formBuilder = this.getFormBuilder();

    if (formBuilder && this.sourceFormDefinition) {
      const formDataFields: FormDataField[] = JSON.parse(this.sourceFormDefinition);
      formBuilder.actions.clearFields();

      for (let i = 0; i < formDataFields.length; i++) {
        formBuilder.actions.addField(formDataFields[i], i);
      }
    }
  }

  getFormData() {
    const parsedFormData = this.parseFormData();
    const json = parsedFormData.error == null ? JSON.stringify(parsedFormData.data) : '';

    return json;
  }

  private validateInputs() {
    if (typeof this.sourceFormDefinition !== 'string') {
      this.sourceFormDefinition = '';
    }
  }

  private getFormBuilder() {
    return this.editorRef.data('formBuilder') as FormBuilder;
  }

  private initializeEditor() {
    if (this.initialized) {
      this.setFormDefinition();
      return;
    }

    invariant(this.options != null);
    this.options.formData = this.sourceFormDefinition ? this.sourceFormDefinition : '[]';
    this.editorRef = (this.$element.find(`#${this.id}`) as TODO).formBuilder(this.options);

    this.initialized = true;
    this.elementRef({ $event: { ref: this } });
  }

  private parseFormData() {
    try {
      const formBuilder = this.getFormBuilder();

      const data = JSON.parse(formBuilder.formData) as FormDataField[];
      return { error: null, data };
    } catch (error) {
      console.error('FormBuilderComponent', 'Failed to parse formData JSON');
      return { error: 'Failed to parse formData JSON', data: null };
    }
  }
}

export const FormBuilderComponentModule = angular
  .module('acme.common.component.form-builder', [])
  .component('acmeFormBuilder', {
    templateUrl: 'common/components/form-builder/form-builder.component.tpl.html',
    controller: FormBuilderController,
    bindings: {
      options: '<',
      sourceFormDefinition: '<',
      elementRef: '&',
    },
  }).name;
